import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/styles';
import Axios from 'axios';
import MUIDataTable from "mui-datatables";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Backdrop from '@material-ui/core/Backdrop';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from "@material-ui/core/FormControl";
import MuiAlert from '@material-ui/lab/Alert';
import Select from "@material-ui/core/Select";
import { customColumns } from './customColumns';
import { DataPreviewModal } from './DataPreviewModal';
import { AlertDialogSlide } from './successAlert';
import { Encryption } from '../../../../utils/index'

function Alert(props) {
  return <MuiAlert elevation={0} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2),
    height: 500,
    width: '100%',
  },
  cardContent: {
    marginTop: theme.spacing(2),
  },
  gridContent: {
    backgroundColor: '#FFFFF',
    fontSize: 14,
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

export const ClientDataTable = () => {
  const classes = useStyles();
  const [tableData, setTableData] = useState('');
  const [open, setOpen] = React.useState(false);
  const [openRow, setRowState] = React.useState('');
  const [openSnack, setOpenSnack] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [snackOpenError, setSnackOpenError] = useState(false);

  const [responsive, setResponsive] = useState("vertical");
  const [tableBodyHeight, setTableBodyHeight] = useState("400px");
  const [tableBodyMaxHeight] = useState("");

  useEffect(() => {
    fetchData();
    // window.onbeforeunload = confirmExit;
    // function confirmExit()
    // {
    //   return "Please Logout out";
    // }
    //eslint-disable-next-line
  }, []);

  const config = {
    headers: {
      "signature": '64cf508d98d5dcb0d35a1e9fb6e4c278f3123b6cf1435036e6b98f4bf8aa86a6',
      // "signature": process.env.REACT_APP_SIGNATURE,
      "Content-Type": 'application/json;charset=UTF-8',
      "username": "KYCUI-TEST",
      "applicationID": "KYCUI",
      "where": null,
      "action": "VIEW_DETAILS",
      "query": "KYC"
    },
  };

  const apiUrl = "https://192.72.53.70:5000/api/KYC/Read";
  // const apiUrl = "https://192.72.53.70/KYC/Read";

  // const fetchData = async () => {
  //   await fetch("/api/clients").then(response => { 
  //           console.log('>>>>',response)            // response.json()
  //           // if(response !== 'Unable to fetch now'){
  //           if(response.status ==="400"){
  //               console.log('we get the data, hallelujah')
  //           }
  //           else{
  //             console.log('we get to the else but hallelujha')
  //           }
  //         })
  //     .catch(() => {
  //       handleCloseSnackBar()
  //       handleOpenSnackError();
  //     });
  // }

  const fetchData = async () => {
    handleToggleSnackBar();
    await Axios.get(apiUrl, config).then(res => {
      if (res.data.response_message === "Customer details successfully Retrieved!") {
        setTableData(res.data.response_data);
        handleCloseSnackBar()
      } else {
        handleCloseSnackBar()
        handleOpenSnackError()
      }
    })
      .catch(() => {
        handleCloseSnackBar()
        handleOpenSnackError();
      });
  }

  const reviewConfig = {
    headers: {
      // "signature": process.env.REACT_APP_SIGNATURE,
      "signature": "64cf508d98d5dcb0d35a1e9fb6e4c278f3123b6cf1435036e6b98f4bf8aa86a6",
      "Content-Type": 'application/json;charset=UTF-8',
    }
  };
  const handleReveiw = async (values) => {
    handleToggleSnackBar();
    // const apiUrl = "https://192.72.53.70/KYC/Update";
    const apiUrl = "https://192.72.53.70:443http://192.72.53.36:9090 http://192.72.53.36:9090:443http://192.72.53.36:9090 http://192.72.53.36:9090:443http://192.72.53.36:9090 http://192.72.53.36:9090:443http://192.72.53.36:9090 http://192.72.53.36:9090:443http://192.72.53.36:9090 http://192.72.53.36:9090:5000/api/KYC/Update";
    const objValues = {
      "username": "KYCUI-TEST",
      "applicationID": "KYCUI",
      "where": values,
      "action": "UPDATE_FORM",
      "query": "KYC"
    }
    const hashedObjValues = Encryption(JSON.stringify(objValues));
    await Axios.post(apiUrl, hashedObjValues, reviewConfig).then(res => {
      // console.log('resp', res)
      if (res.data.response_message === "Succesfully Reviewed!") {
        handleCloseSnackBar()
        fetchData();
        handleOpenSuccess();
      } else {
        handleCloseSnackBar()
        handleOpenSnackError()
      }
    })
      .catch(() => {
        handleCloseSnackBar()
        handleOpenSnackError();
      });
  }

  const handleOpenSuccess = () => {
    setOpenSuccess(true);
  };

  const handleCloseSuccess = () => {
    setOpenSuccess(false);
  };

  const handleOpenSnackError = () => {  
    setSnackOpenError(true)
  }

  const handleCloseSnackError = (e, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackOpenError(false)
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseSnackBar = () => {
    setOpenSnack(false);
  };

  const handleToggleSnackBar = () => {
    setOpenSnack(true);
  };

  const options = {
    filter: false,
    filterType: "dropdown",
    responsive,
    viewColumns: false,
    tableBodyHeight,
    tableBodyMaxHeight,
    selectableRows: false,
    selectableRowsOnClick: false,
    onRowClick: (rowData) => {
      handleClickOpen();
      setRowState(rowData);
    }
  };

  const tableDataValue = tableData.length === 0 ? [] : (
    JSON.parse(tableData).filter(value => value.status === "PENDING").map(table => {
      let dataArray = [table.id, table.formID, table.surname, table.otherNames, table.accountName, table.accountNumber,
      table.branch, table.date, table.gender, table.maritalStatus, table.idType, table.dateOfBirth, table.nationality,
      table.country, table.cardNumber, table.expiryDate, table.phone, table.otherNumber, table.poBox, table.postalOffice,
      table.email, table.city, table.province, table.village, table.zipcode, table.zone, table.sourcesOfIncome, table.othersourcesOfIncome,
      table.alternativeSourceOfIncome, table.currentEmployer, table.currentRole, table.workplaceAddress, table.periodWithWorkplace,
      table.monthlyGrossIncome, table.signingMandate, table.otherSigningMandate, table.bankNameDeposit, table.depositAccountNames,
      table.depositAccountNumber, table.telecomName, table.registeredNames, table.registeredNumber, table.policy, table.status, table.comment,
      table.nokName, table.nokEmail, table.nokPhone, table.nokAddress, table.nokRelationship];
      return dataArray;
    })
  );

  return (
    <div className={classes.root}>
      <Backdrop className={classes.backdrop} open={openSnack}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {open === true && openRow !== '' ? (
        <DataPreviewModal handleClickOpen={handleClickOpen} handleClose={handleClose} open={open} openRow={openRow}
        handleToggleSnackBar={handleToggleSnackBar} handleReveiw={handleReveiw} handleOpenSnackError={handleOpenSnackError} fetchData={fetchData} />
      ) : null}
      <AlertDialogSlide fetchData={fetchData} openSuccess={openSuccess} handleCloseSuccess={handleCloseSuccess} />
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={snackOpenError}
        autoHideDuration={3000}
        onClose={handleCloseSnackError}
        key="topcenter"
        action={
          <React.Fragment>
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackError}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      >
        <Alert onClose={handleCloseSnackError} severity="warning" className={classes.snackFont}>
          Unable to perform request now, Please try again in a few minutes or contact support.
                    </Alert>
      </Snackbar>
      <FormControl>
        <InputLabel id="demo-simple-select-label">Responsive Option</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={responsive}
          style={{ width: "200px", marginBottom: "10px", marginRight: 10 }}
          onChange={(e) => setResponsive(e.target.value)}
        >
          <MenuItem value={"vertical"}>vertical</MenuItem>
          <MenuItem value={"standard"}>standard</MenuItem>
          <MenuItem value={"simple"}>simple</MenuItem>

          <MenuItem value={"scroll"}>scroll (deprecated)</MenuItem>
          <MenuItem value={"scrollMaxHeight"}>
            scrollMaxHeight (deprecated)
          </MenuItem>
          <MenuItem value={"stacked"}>stacked (deprecated)</MenuItem>
        </Select>
      </FormControl>
      <FormControl>
        <InputLabel id="demo-simple-select-label">Table Body Height</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={tableBodyHeight}
          style={{ width: "200px", marginBottom: "10px", marginRight: 10 }}
          onChange={(e) => setTableBodyHeight(e.target.value)}
        >
          <MenuItem value={""}>[blank]</MenuItem>
          <MenuItem value={"400px"}>400px</MenuItem>
          <MenuItem value={"800px"}>800px</MenuItem>
          <MenuItem value={"100%"}>100%</MenuItem>
        </Select>
        <div>
          {/* {handleData()} */}
        </div>
      </FormControl>
      <MUIDataTable
        title={"Post Bank KYC Updated Information"}
        data={tableDataValue}
        columns={customColumns}
        // columns={columns}
        options={options}
      />

      {/* <HomeToolbar />
        <Card className={classes.cardContent}>
          <CardContent className={classes.content}>
            <DataGrid rows={rows} className={classes.gridContent} columns={columns} pageSize={10} checkboxSelection />
          </CardContent>
        </Card> */}
    </div>
  );
}
export default ClientDataTable;